import {
  PDFDocument,
  StandardFonts,
  rgb
} from 'pdf-lib';

export const buildPDF = async (pdfBuffer, values) => {
  const pdfDoc = await PDFDocument.load(pdfBuffer);
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { height } = firstPage.getSize();

  if (values.revisitingLead) {
    firstPage.drawText('You will receive a copy of this', {
      x: 75,
      y: height - 215,
      size: 12,
      font: helveticaFont,
      color: rgb(1, 0, 0, 0)
    });

    firstPage.drawText('agreement with your details applied', {
      x: 75,
      y: height - 230,
      size: 12,
      font: helveticaFont,
      color: rgb(1, 0, 0, 0)
    });
  } else {
    firstPage.drawText(`${values.firstName} ${values.lastName}`, {
      x: 75,
      y: height - 200,
      size: 12,
      font: helveticaFont
    });

    firstPage.drawText(`${values.houseNumName}, ${values.streetRoad}`, {
      x: 75,
      y: height - 215,
      size: 12,
      font: helveticaFont
    });

    firstPage.drawText(values.town, {
      x: 75,
      y: height - 230,
      size: 12,
      font: helveticaFont
    });

    firstPage.drawText(values.postCode, {
      x: 75,
      y: height - 245,
      size: 12,
      font: helveticaFont
    });

    firstPage.drawText(values.ref, {
      x: 375,
      y: height - 222,
      size: 10,
      font: helveticaFont
    });

    firstPage.drawText(values.today, {
      x: 355,
      y: height - 259,
      size: 10,
      font: helveticaFont
    });
  }

  const pdfBytes = await pdfDoc.save();
  const bytes = new Uint8Array(pdfBytes);
  const blob = new Blob([bytes], { type: "application/pdf" });
  return URL.createObjectURL(blob);
};
